import type { RegisterCardKey } from './registerCards';

/**
 * Pannello destro di RegisterSplitLayout: per ogni step la card del sito da
 * cui parte il carosello (RegisterCardCarousel, poi crossfade in loop).
 * Lo step "modules" non è qui: usa SidebarPreview al posto del carosello.
 */
export interface RegisterVisual {
  startCard: RegisterCardKey;
}

export const REGISTER_VISUALS: Record<
  'entry' | 'verify' | 'password' | 'profile' | 'company' | 'discovery' | 'connect' | 'team',
  RegisterVisual
> = {
  entry:     { startCard: 'lead' },
  verify:    { startCard: 'quote' },
  password:  { startCard: 'automations' },
  profile:   { startCard: 'portal' },
  company:   { startCard: 'whatsapp' },
  discovery: { startCard: 'marketing' },
  connect:   { startCard: 'prenotazioni' },
  team:      { startCard: 'wiki' },
};
